import { datadogRum } from '@datadog/browser-rum';
import { v4 as uuidv4 } from 'uuid';

import packageJson from '../../package.json';
import { AsyncProviderConfig } from 'launchdarkly-react-client-sdk';

const fallbackFlags = {
  // operational
  'show-application-maintenance-mode': false,
  'show-price-cap-feature': '',
  'show-high-demand-warning': false,
  // app config
  'config-time-of-use-tariff': true,
  'config-remove-green-deal-exception': true,
  'config-ev-tariff-id': null,
  'config-price-cap-dd-savings': {
    AMOUNT: {
      DUAL: '£60',
      ELECTRIC: '£60',
      GAS: '£120'
    },
    HEAT_PUMP_AMOUNT: '£316',
    DATE: 'April 2025'
  },
  // journeys
  'allow-journey-default': true,
  'allow-journey-voicesales-homemove': true,
  'allow-journey-voicesales-winback': true,
  'allow-journey-voicesales-aquisition': true,
  'allow-journey-nondomestic-transfer': true,
  'allow-journey-move-in': true,
  // release
  'release-heat-pump-registration': false,
  'release-solar-registration': false,
  'release-paper-comms': false,
  'release-revamp-journey': false,
  //experiment
  'experiment-tariff-card-config': {},
  'experiment-default-consumption-type': false
};

const uuid = uuidv4();

export const getLDContext = () => {
  return {
    kind: 'multi',

    user: {
      anonymous: true,
      key: uuid
    }
  };
};

const launchDarklyConfig: AsyncProviderConfig = {
  clientSideID: import.meta.env.VITE_LAUNCHDARKLY_CLIENT_SIDE_ID,
  flags: fallbackFlags,
  context: getLDContext(),
  options: {
    application: {
      id: `direct-sales-${packageJson.version}`,
      version: packageJson.version
    },
    bootstrap: 'localStorage',
    inspectors: [
      {
        type: 'flag-used',
        name: 'direct-sales-feature-flags',
        method: /* istanbul ignore next -- @preserve */ (
          flagKey,
          flagDetail
        ) => {
          datadogRum.addFeatureFlagEvaluation(flagKey, flagDetail.value);
        }
      }
    ]
  }
};

export default launchDarklyConfig;
